import store from '@/store'

/**
 * @param {Array} value
 * @returns {Boolean}
 * @example see @/views/permission/directive.vue
 */
export default function checkPermission(value) {
  if (value && value instanceof Array && value.length > 0) {
    const roles = store.getters && store.getters.roles

    // 判定是否是超级管理员
    if (roles.indexOf('admin:*') > -1) {
      return true
    }
    // 判定特殊权限
    const permissions = store.getters && store.getters.permissions
    const permissionRoles = value
    const hasPermission = permissions.some(permission => {
      return permissionRoles.includes(permission)
    })
    return hasPermission
  } else {
    console.error(`need roles! Like v-permission="['admin','editor']"`)
    return false
  }
}

